import {
    createSelector,
} from '@reduxjs/toolkit';

import i18n from '~shared/utils/i18n';

import {
    selectAllSinglesPayout,
    selectSinglesNoAvailableReturns,
} from './singlesPayoutSelectors';

import {
    selectUserSelections,
    selectHasAnySpSelected,
    selectSinglesStake,
} from './userSelectionsSelectors';

import {
    calculateSinglesTabAllSinglesPayout,
    calculateParlayPayout,
    calculateAllSinglesPayout,
} from '~Betslip/utils/payoutCalculators';

import {
    selectSelectionDetails,
} from './selectionDetailsSelectors';

import {
    selectUserSinglesInParlay,
    selectUserParlay,
    selectParlay,
} from './parlaySelectors';

import {
    selectAllFreeBets,
} from './freeBetSelectors';

const selectSinglesTotalPayout = createSelector(
    [
        selectUserSelections,
        selectSelectionDetails,
        selectAllFreeBets,
    ],
    (userSelections, selectionDetails, freebets) => {
        return calculateSinglesTabAllSinglesPayout(userSelections, selectionDetails, freebets);
    }
);


export const selectSinglesTabTotalPayout = createSelector(
    [
        selectAllSinglesPayout,
        selectSinglesTotalPayout,
        selectSinglesNoAvailableReturns,
        selectSinglesStake,
    ],
    (allSingles, totalPayout, noAvailableReturns, singlesStake) => {
        if (noAvailableReturns && singlesStake > 0) {
            return i18n.t('betslip.na');
        }

        if (allSingles.payout > 0) {
            return allSingles.payout;
        }

        return totalPayout;
    }
);

export const selectParlaySinglesTotalPayout = createSelector(
    [
        selectUserSinglesInParlay,
        selectSelectionDetails,
        selectHasAnySpSelected,
        selectSinglesNoAvailableReturns,
    ],
    (parlaySingles, selectionDetails, hasSpSelected, noAvailableReturns) => {
        if ((hasSpSelected || noAvailableReturns) && Number(parlaySingles.stake) > 0) {
            return i18n.t('betslip.na');
        }

        return calculateAllSinglesPayout(parlaySingles, selectionDetails);
    }
);

export const selectParlayParlayPayout = createSelector(
    [
        selectParlay,
        selectUserParlay,
        selectSelectionDetails,
        selectHasAnySpSelected,
        selectAllFreeBets,
    ],
    (parlay, userParlay, selections, hasSpSelected, freebets) => {
        const { stake, each_way_selected, free_bet_id } = userParlay;

        const betslipId = parlay?.id;
        let freebetStake = null;

        if (freebets && freebets[betslipId]) {
            const selectedFreebet = freebets[betslipId].find(fb => fb.id === free_bet_id);
            freebetStake = selectedFreebet?.value;
        }

        if (hasSpSelected && Number(stake) > 0) {
            return i18n.t('betslip.na');
        }

        return calculateParlayPayout(selections, stake, each_way_selected, freebetStake);
    }
);

export const selectParlayTabTotalPayout = createSelector(
    [
        selectParlaySinglesTotalPayout,
        selectParlayParlayPayout,
    ],
    (singlesPayout, parlayPayout) => {
        if (isNaN(singlesPayout) || isNaN(parlayPayout)) {
            return i18n.t('betslip.na');
        }

        return singlesPayout + parlayPayout;
    }
);
